import Column from '@components/Column';
import Divider from '@components/Divider';
import Row from '@components/Row';
import Text from '@components/Text';
import styled from '@emotion/styled';
import useGlobalName from '@hooks/useGlobalName';
import { OptionGroup } from '@models/item';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import CheckboxOptions from './CheckboxOptions';
import useIsHotSelected from './hooks/useIsHotSelected';
import RadioOptions from './RadioOptions';

interface Props {
    optionGroup: OptionGroup;
    itemId: string;
    noDivider?: boolean;
}

function TextOption({ optionGroup, itemId, noDivider }:Props) {
    const {
        options, name, uiButtonType, minSelection,
        optionGroupId, nameEn, nameKo, nameJa,
    } = optionGroup;
    const { t } = useTranslation('item');
    const optionGroupName = useGlobalName({
        nameKo, nameEn, name, nameJa,
    });
    const isHotSelected = useIsHotSelected();
    const iceOptionGroupNames = ['氷選択', t('option.ice')];
    // HOT 이 선택되었을 때 얼음 옵션 그룹 미표시
    if (isHotSelected && iceOptionGroupNames.includes(optionGroupName)) {
        return null;
    }

    return (
        <Column fullWidth>
            {(!noDivider) && (<Divider/>)}
            <Container fullWidth spacing={16} >
                <Row>
                    <Text size='lg' fontWeight='bold'>
                        {optionGroupName}
                    </Text>
                    {(minSelection > 0) && (
                        <RequiredText>{t('option.required')}</RequiredText>
                    )}
                </Row>
                {uiButtonType === 'CHECKBOX' && (
                    <CheckboxOptions options={options} optionGroupId={optionGroupId} itemId={itemId} />
                )}
                {uiButtonType === 'RADIO' && (
                    <RadioOptions options={options} optionGroupId={optionGroupId} itemId={itemId} />
                )}
            </Container>
        </Column>
    );
}

const Container = styled(Column)`
    padding: 16px 20px;
`;

const RequiredText = styled.span`
    font-size: 14px;
    font-weight: 400;
    color: var(--color-gray6);
    margin-left: 4px;
`;

export default TextOption;
